import { TenantProcess, TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';

export class TenantProcessStateBaseDTO {
  processId: TenantProcess;

  typeOfEntity: number;

  entityId: number;

  status: TenantProcessStatus;

  modified?: string;

  data: string | undefined;

  constructor() {
    this.processId = TenantProcess.None;
    this.typeOfEntity = 0;
    this.entityId = 0;
    this.status = TenantProcessStatus.NotStarted;
  }
}
